export default import.meta.ROLLDOWN_FILE_URL_oEt8k0ZG7EV$3JSkDP93sQ